import { useAuthLibContext as w } from "../contexts/AuthLibContext.js";
import d from "./useGetOAuthLink.js";
import { SsoPurpose as l } from "../../temp-lib/constants/account.js";
import { ERROR_CODE as g } from "../../temp-lib/constants/error.js";
import { useAccountContext as h } from "../../temp-lib/contexts/account/AccountContext.js";
import { CustomError as R } from "../../temp-lib/errors/customError.js";
import * as m from "ramda";
import { useCallback as i } from "react";
const k = () => {
  const { fetch: r } = d(), { storeSsoState: s } = h(), { config: c } = w(), e = i(() => {
    const { login: o } = c;
    if (m.isNil(o))
      throw new R(
        'config "login" is not defined',
        g.GENERAL.MISSING_CONFIG
      );
    return `${window.location.protocol}//${window.location.host}/${o.sso.redirectPath}`;
  }, [c]), n = i(
    async (o, f) => {
      const a = e(), t = await r(o, a);
      m.isNotNil(t) && (s({
        state: t == null ? void 0 : t.state,
        appType: o,
        redirectURI: a,
        currentUrl: location.pathname + location.search,
        purpose: f
      }), window.location.assign(t.url));
    },
    [r, e, s]
  ), p = i(
    async (o) => {
      await n(o, l.LinkApp);
    },
    [n]
  ), u = i(
    async (o) => {
      await n(o, l.Login);
    },
    [n]
  );
  return {
    link: p,
    login: u
  };
};
export {
  k as default
};
//# sourceMappingURL=useSsoAuth.js.map
